import { useI18nContext } from '@/i18n/i18n-react';
import { CreateAudienceButton } from '@/components/audiences/create-audience-button';
import { cn } from '@/lib/utils';

interface AudienceEmptyStateProps {
  tenantSlug: string;
  className?: string;
}

export function AudienceEmptyState({
  tenantSlug,
  className,
}: AudienceEmptyStateProps) {
  const { LL } = useI18nContext();

  return (
    <div
      className={cn(
        'flex min-h-[40vh] min-w-0 flex-col items-center justify-center gap-4 px-4 text-center',
        className
      )}
    >
      <div className="mt-10 flex max-w-md flex-col gap-2 sm:mt-12">
        <h2 className="text-2xl font-medium tracking-tight sm:text-3xl">
          {LL.audiences.title()}
        </h2>
        <p className="text-sm text-muted-foreground sm:text-base">
          {LL.audiences.emptyStateDescription()}
        </p>
      </div>
      <CreateAudienceButton tenantSlug={tenantSlug} />
    </div>
  );
}
